import { create } from "zustand";
import axios from "axios";
import { URL } from "../constant/url";

export const useProductStore = create((set) => ({
  products: [],
  loading: false,
  error: null,

  // ✅ Fetch all products from backend
  fetchProducts: async () => {
    set({ loading: true, error: null });
    try {
      const res = await axios.get(`${URL}/api/products`); // ← adjust URL if needed
      set({ products: res.data, loading: false });
      // console.log(res.data);
    } catch (error) {
      console.error("Error fetching products:", error);
      set({ error: "Failed to load products", loading: false });
    }
  },
}));
